import { useEffect } from 'react'
import { signInAgain } from '../lib/session'

/**
 * After "Sign out". pas-auth ended its own session, but not the Microsoft one (IDPSignout is off),
 * so signing in again here may need no password. Nothing signs in until the person asks.
 */
export function SignedOut() {
  useEffect(() => {
    document.title = 'Signed out'
  }, [])
  return (
    <main>
      <div className="card">
        <h2 data-icon="logout">You are signed out of Hearing Aid Orders</h2>
        <p>
          Your Microsoft session may still be open, so signing in again may not ask for a password. On a shared
          computer, close the browser.
        </p>
        <button type="button" className="btn filled" data-icon="login" onClick={() => void signInAgain()}>
          Sign in
        </button>
      </div>
    </main>
  )
}
